<div appStickyHeader [animate]="config?.animateHeader" [headerTopSticky]="config?.headerTopSticky" [isHome]="config?.headerClass?.match('homepage-header')" [class]="config?.headerClass || 'topsticky'" [ngClass]="{'pos-rel-header': !config?.animateHeader}">
<header id="navbar" class="d-none d-lg-block">
  <div id="navUpdates">
    <div class="container">
      <div class="top desktop-menus">
        <div *ngIf="!config?.isStandaloneNgoPage" class="logo float-left" [ngClass]="['stories','stories_listing'].includes(variablesService.pageName)?'new_year':''">
          <a [href]= "environment.APP.DOMAIN_URL" (click)="onLogoClick($event)">
            <img loading="lazy" [src]="logoUrlLight" width="70" height="35" alt="Ketto – Crowdfunding in India"/>
          </a>
        </div>
        <div class="logo float-left" [ngClass]="{'customLogo': isDynamicLogo}" *ngIf="isDynamicLogo">
          <a (click)="onCustomLogoClick($event)">
            <img loading="lazy" [src]="customLogoUrl" width="70" alt="Campaign Logo" [ngClass]="{'customLogo': isDynamicLogo}"/>
          </a>
        </div>
        <div *ngIf="config?.trustedLine" class="primary-menu trusted-line">
          Ketto is a Crowdfunding Platform based out of India.
        </div>
        <div class="flex-menus">
        <div *ngIf="config?.showMenus" class="primary-menu">
            <a [routerLink]="['/crowdfunding/fundraisers']" (click)="onMenuItemClicked()">Browse Fundraisers</a>
            <a href="javascript:void(0)" class="fundraise-for" [matMenuTriggerFor]="fundraise_for" >Fundraise For <mat-icon class="arrow-down">arrow_drop_down</mat-icon></a>
            <mat-menu #fundraise_for="matMenu">
              <button mat-menu-item *ngFor="let cause of frCauses" (click)="startFrFor(cause)">{{ cause?.label }}</button>
            </mat-menu>
            <a [routerLink]="['/crowdfunding']" *ngIf="!hasDonations; else impact"  (click)="onMenuItemClicked()">How It Works</a>
            <ng-template #impact>
              <a [routerLink]="['/new/portfolio']" (click)="myImpactSystemEvent(); onMenuItemClicked()">My Impact</a>
            </ng-template>
            <a *ngIf="config?.showSearch" href="javascript:;">|</a>
            <a *ngIf="config?.showSearch" href="javascript:void(0)" (click)="showSearchBox()">
              <span><mat-icon>search</mat-icon>Search</span>
            </a>
        </div>
        <div class="login-menu">
          <span class="menu-spacer"></span>
          <a *ngIf="config?.showMenus" (click)="pushHeaderButton('campaign/start_campaign.php', $event)" href="javascript:void(0)" class="start-a-fundraiser" mat-button>Start a Fundraiser</a>
          <a *ngIf="config?.showCurrency" href="javascript:void(0)" class="currency-switcher">
            <ng-template [ngTemplateOutlet]="languageDropdown" *ngIf="availableLangs?.length > 1 && config?.showLanguage"></ng-template>
          </a>
          <a *ngIf="config.showDownloadApp && !isAnyActiveSip && variablesService.pageName?.match('home|stories|campaign') && !isAppUser" href="javascript:void(0)" class="download-app">
            <ng-template [ngTemplateOutlet]="downloadAppDropdown"></ng-template>
          </a>
          <a *ngIf="config?.showCurrency" href="javascript:void(0)" class="currency-switcher">
            <ng-template [ngTemplateOutlet]="currencyDropdown"></ng-template>
          </a>
          <div *ngIf="config?.showSecure" class="secure-tag" [ngClass]="{'standaloneHeader': config?.isStandaloneNgoPage}">
            <img loading="lazy" data-src="/assets/images/story/icon-secure-lock.png" alt="secure lock" />
            <div class="secure-txt">100% Secure</div>
          </div>
          <div *ngIf="isLoggedIn" class="manage-campaign-btn">
            <button *ngIf="checkForManageFr()" type="button" (click)="goToManageFund()" mat-stroked-button>Manage</button>
          </div>

          <a (click)="openLoginPopup(loginPopupTemp)" href="javascript:void(0)" *ngIf="!isLoggedIn && config?.showProfile">Sign In</a>
          <a href="javascript:void(0)" *ngIf="isLoggedIn && config?.showProfile" class="loggedin-profile">
            <mat-chip-list *ngIf="!variablesService?.isAgent">
              <ng-container *ngIf="isHomev2">
                <mat-chip class="logged-in-user" (click)="toggleDrawer()">
                  <ng-container [ngTemplateOutlet]="matChipItem"></ng-container>
                </mat-chip>
              </ng-container>
              <ng-container *ngIf="!isHomev2">
                <mat-chip class="logged-in-user" [matMenuTriggerFor]="loggedInMenu">
                  <ng-container [ngTemplateOutlet]="matChipItem"></ng-container>
                </mat-chip>
              </ng-container>
            </mat-chip-list>
            <mat-menu #loggedInMenu="matMenu">
              <button mat-menu-item> <b>{{ userData?.full_name }}</b> </button>
              <span *ngIf="!userData?.is_hospital">
                <span *ngIf="userData?.entity_type !== 'ngo'">
                  <a [href]="sipRedirect('editprofile')" mat-menu-item>View Profile</a>
                  <hr class="custom-hr">
                  <a [href]="environment.manage_domain + '/manage/list'" mat-menu-item>My Fundraisers</a>
                  <hr class="custom-hr">
                  <a [href]="sipRedirect('mydonations')" mat-menu-item>My Contributions</a>
                  <hr class="custom-hr">
                  <a [href]="isMemorialSip && !isAnyActiveSip?'/new/thankyou?or=sps&sip_cause=memorial':'/new/portfolio'" (click)="sendSystemEvent()" mat-menu-item>{{isAnyActiveSip?'My SIP Dashboard':'View My Impact'}}</a>


                </span>
                <span *ngIf="userData?.entity_type === 'ngo'">
                  <a href="/ngo/dashboard/ngo-dashboard.php" mat-menu-item>View Dashboard</a>
                </span>
              </span>
              <span *ngIf="userData?.is_hospital">
                <a href="/manage/index.html#!/" mat-menu-item>View Dashboard</a>
              </span>
              <hr class="custom-hr">
              <a (click)="whatsappChat()" [href]="'https://api.whatsapp.com/send?phone=91' + variablesService.contactUsMobNumber" target="_blank" class="whatsapp-btn" mat-menu-item><i class="icon-whatsapp"></i>Get us on Whatsapp</a>
              <hr class="custom-hr">
              <button mat-menu-item (click)="logout()" class="logout-btn">Logout</button>
            </mat-menu>
          </a>
        </div>
      </div>
      </div>
    </div>
  </div>
</header>
</div>

<header id="navbar" class="d-lg-none" [ngClass]="config?.headerClass">
  <div appStickyHeader [animate]="config?.animateHeader" *ngIf="!isAppUser">
    <app-module-loader moduleId="download-app-banner" selector="app-download-app-banner"
                      [load]="isMobile && isAnyActiveSip && lastUrlName === '' && !isAppUser"
                      [inputs]="{ config: {v: 6, title: 'Manage monthly contributions'}}">
    </app-module-loader>
    <app-module-loader moduleId="download-app-banner" selector="app-download-app-banner"
                      [load]="isMobile && userData && !isAnyActiveSip && variablesService.pageName?.match('home|stories|campaign') && config?.headerClass?.match('download-app-banner') && !isAppUser"
                      [inputs]="{ config: {v: 6, title: 'Track your contributions on the go'} }">
    </app-module-loader>
  </div>
  <div class="menus">
    <mat-sidenav-container class="nav-container">
      <mat-sidenav-content class="mobile-header" appStickyHeader [animate]="config?.animateHeader" [headerTopSticky]="config?.headerTopSticky" [isHome]="config?.headerClass?.match('homepage-header')" [class]="config?.headerClass || 'topsticky'" [ngClass]="{'pos-rel-header': !config?.animateHeader, 'top-60': (isAnyActiveSip && isMobile && !isAppUser) || (userData && !isAnyActiveSip && isMobile && config?.headerClass?.match('download-app-banner') && variablesService.pageName?.match('home|stories|campaign'))}">
        <div *ngIf="!config?.isStandaloneNgoPage" class="logo float-left" [ngClass]="['stories','stories_listing'].includes(variablesService.pageName)?'new_year':''">
          <a [href]= "environment.APP.DOMAIN_URL" (click)="onLogoClick($event)">
            <img loading="lazy" [src]="logoUrlLight" alt="Ketto – Crowdfunding in India" width="70" height="35"/>
          </a>
        </div>
        <div class="logo float-left" [ngClass]="{'customLogo': isDynamicLogo}" *ngIf="isDynamicLogo">
          <a (click)="onCustomLogoClick($event)">
            <img loading="lazy" [src]="customLogoUrl" alt="Campaign Logo" [ngClass]="{'customLogo': isDynamicLogo}" width="70" height="35"/>
          </a>
        </div>
        <a *ngIf="config?.showCurrency" href="javascript:void(0)" class="currency-anchor" [ngClass]="{'l-right': !config?.showProfile}">
          <ng-template [ngTemplateOutlet]="languageDropdown" *ngIf="availableLangs?.length > 1 && config?.showLanguage"></ng-template>
        </a>
        <a *ngIf="config?.showDownloadApp && !isDynamicLogo && !isAnyActiveSip && variablesService.pageName?.match('home|stories|campaign') && !isAppUser" href="javascript:void(0)" class="currency-anchor download-app" [ngClass]="{'l-right': !config?.showProfile}">
          <ng-template [ngTemplateOutlet]="downloadAppDropdown"></ng-template>
        </a>
        <a *ngIf="config?.showCurrency" href="javascript:void(0)" class="currency-anchor" [ngClass]="{'c-right': !config?.showProfile}">
          <ng-template [ngTemplateOutlet]="currencyDropdown"></ng-template>
        </a>
        <button mat-icon-button class="menu-button" *ngIf="variablesService.thirdPartyApp && userData" [matMenuTriggerFor]="phonePeMenu">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #phonePeMenu="matMenu">
          <a [href]="sipRedirect('mydonations')" mat-menu-item>My Contributions</a>
        </mat-menu>
        <button *ngIf="config?.showProfile" class="menu-button" [hidden]="config?.enableDrawer && isMobile" aria-label="menu-button" mat-icon-button (click)="sidenav.toggle()">
          <span *ngIf="!isLoggedIn">
            <mat-icon>menu</mat-icon>
          </span>
          <span *ngIf="isLoggedIn" [hidden]="isHomev2 && isMobile">
            <img loading="lazy" class="user-image" [attr.data-src]="userData?.avtar?.cdn_path" [alt]="userData?.full_name" [hidden]="showUserIcon === true"/>
            <i class="icon-user1" *ngIf="showUserIcon === true" ></i>
          </span>
        </button>
      </mat-sidenav-content>
      <mat-sidenav [hidden]="!config?.showProfile" #sidenav mode="push" position="end">
        <ng-container *ngIf="!isHomev2">
          <div class="logo-inside float-left">
            <img loading="lazy" [src]="logoUrlDark" alt="dark logo" width="70" height="36" />
          </div>
          <p><button mat-icon-button (click)="sidenav.close()"><mat-icon class="close-btn">close</mat-icon></button></p>
          <div class="search-bar">
            <div class="row search-wrapper d-block d-lg-none d-md-block d-sm-block" *ngIf="config?.showSearch && sidenav?.opened">
              <app-module-loader moduleId="search-bar" selector="app-search-bar" [load]="true" [outputs]="{ closeSearchBar: closeSearchBarHandler }"></app-module-loader>
            </div>
          </div>
          <div *ngIf="isMobile" class="nudge-container" [ngClass]="{'nudge-close': hideNudge}">
            <app-nudge-login (hide)="hideNudge=$event"></app-nudge-login>
          </div>
          <div *ngIf="userData" class="my-donations">
            To view fundraisers you have supported on Ketto
            <a href="javascript:void(0)" (click)="goToMyDonations(loginPopupTemp)" class="word-wrap">Click here</a>
          </div>
          <div class="main-menus" [hidden]="searchQuery">
            <div *ngIf="!userData?.is_hospital">
              <div *ngIf="userData?.entity_type !== 'ngo'">
                <p *ngIf="isLoggedIn"><a [href]="environment.manage_domain + '/manage/list'">My Fundraisers</a></p>
                <p *ngIf="isLoggedIn"><a [href]="sipRedirect('mydonations')">My Contributions</a></p>
                <div *ngIf="exist_sip">
                  <app-sip-hamburger></app-sip-hamburger>
                </div>
                <p *ngIf="isLoggedIn"><a [href]="isMemorialSip && !isAnyActiveSip?'/new/thankyou?or=sps&sip_cause=memorial':'/new/portfolio'" (click)="sendSystemEvent()">{{isAnyActiveSip?'My SIP Dashboard':'View My Impact'}}</a></p>
  
              </div>
              <p *ngIf="userData?.entity_type === 'ngo'">
                <a href="/ngo/dashboard/ngo-dashboard.php">View Dashboard</a>
              </p>
            </div>
            <p *ngIf="isLoggedIn && !userData?.is_hospital">
              <a *ngIf="checkForManageFr()" [href]="environment.manage_domain + '/manage/'+variablesService?.fundraiser?.id + '/dashboard'" >Manage Campaign</a>
            </p>
            <p *ngIf="userData?.is_hospital">
              <a href="/manage/index.html#!/">View Dashboard</a>
            </p>
            <p><a [routerLink]="['/crowdfunding/fundraisers']" (click)="sidenav.close()">Browse Fundraisers</a></p>
            <input type="checkbox" class="checkbox" id="showall">
            <p class="fundraise-for"><a href="javascript:void(0)" [matMenuTriggerFor]="fundraise_for">Fundraise For <mat-icon class="arrow-down">arrow_drop_down</mat-icon></a></p>
            <mat-menu #fundraise_for="matMenu">
              <button mat-menu-item *ngFor="let cause of frCauses" (click)="startFrFor(cause)">{{ cause?.label }}</button>
            </mat-menu>
            <p><a [routerLink]="['/crowdfunding']" (click)="sidenav.close()">How It Works</a></p>
            <p><a (click)="whatsappChat()" [href]="'https://api.whatsapp.com/send?phone=91' + variablesService.contactUsMobNumber" target="_blank" rel="noopener">Get us on Whatsapp</a></p>
            <p><a href="javascript:void(0)" (click)="openLoginPopup(loginPopupTemp)" *ngIf="!isLoggedIn">Sign In</a></p>
            <p *ngIf="isLoggedIn && !utilService.isApp()"><a href="javascript:void(0)" (click)="logout();sidenav.close();">Logout</a></p>
          </div>
          <div class="start-btn-wrapper" [hidden]="searchQuery" [ngClass]="{'button-docked': !isLoggedIn, 'button-undocked': isLoggedIn}">
            <a (click)="pushHeaderButton('campaign/start_campaign.php', $event)" href="javascript:void(0)" class="start-btn" mat-button>START A FUNDRAISER</a>
          </div>
        </ng-container>
        <ng-container *ngIf="isMobile && isHomev2" [ngTemplateOutlet]="drawerContainer"></ng-container>
      </mat-sidenav>
    </mat-sidenav-container>
  </div>
</header>

<div class="search-container d-none d-md-none d-lg-block" *ngIf="config?.showSearch && isSearchBoxVisible">
  <div (click)="isSearchBoxVisible = false" class="search-overlay"></div>
  <div class="search-holder">
    <div class=grid-container>
      <span class="icon-close close-button" (click)="isSearchBoxVisible = false" data-close="" aria-label="Show navigation modal"
        aria-expanded="true">
        <span aria-hidden="true">×</span>
      </span>
      <div class="search-ketto">Search Ketto</div>
      <app-module-loader moduleId="search-bar" selector="app-search-bar" [load]="isSearchBoxVisible" [outputs]="{ closeSearchBar: closeSearchBarHandler }"></app-module-loader>
    </div>
    <div class="my-donations">
      <a href="javascript:void(0)" (click)="goToMyDonations(loginPopupTemp)"> Click here </a> to view fundraisers you have supported on Ketto
    </div>
  </div>
</div>

<!-- Currency dropdown template -->
<ng-template #currencyDropdown>
  <span class="d-lg-block d-md-block d-none">
    <mat-chip-list>
      <mat-chip class="toolbar-currency" [matMenuTriggerFor]="currencyMenu">
        <div class="icon-size" [innerHTML]="currencySymbol"></div>
        <mat-icon>arrow_drop_down</mat-icon>
      </mat-chip>
    </mat-chip-list>
    <mat-menu #currencyMenu="matMenu" class="menu">
      <div *ngFor="let item of countries">
        <button class="menu-item" mat-menu-item (click)="setCurrencyFromMenu(item)">
          <span class="icon-size" [innerHTML]="item?.symbol"></span>
        </button>
      </div>
    </mat-menu>
  </span>
  <mat-chip-list class="d-lg-none d-md-none d-block">
    <mat-chip class="currency-chip toolbar-currency">
      <select class="currency-select" (change)="setCurrencyFromMenu($event, 'select')" [(ngModel)]="currency">
        <option *ngFor="let item of countries" [value]="item?.currency" [selected]="currency==item?.currency">
          <span class="icon-size" [innerHTML]="item?.symbol"></span>
        </option>
      </select>
      <mat-icon class="icon">arrow_drop_down</mat-icon>
    </mat-chip>
  </mat-chip-list>
</ng-template>


<ng-template #languageDropdown>
  <span class="d-lg-block d-md-block d-none">
    <mat-chip-list>
      <mat-chip class="toolbar-currency" [matMenuTriggerFor]="languageMenu">
        <div [innerHTML]="languages[this.variablesService.tranlatedLanguage]"></div>
        <mat-icon>arrow_drop_down</mat-icon>
      </mat-chip>
    </mat-chip-list>
    <mat-menu #languageMenu="matMenu" class="menu">
      <div *ngFor="let lang of availableLangs">
        <button class="menu-item" mat-menu-item (click)="setTranslatorLang(lang.key)">
          <span class="" [innerHTML]="lang.value"></span>
        </button>
      </div>
    </mat-menu>
  </span>
  <mat-chip-list class="d-lg-none d-md-none d-block">
    <mat-chip class="currency-chip toolbar-currency">
      <select class="language-select" #langSelect (change)="setTranslatorLang(langSelect.value)">
        <option *ngFor="let lang of availableLangs" [value]="lang.key" [selected]="lang.key === variablesService.tranlatedLanguage">
          <span [innerHTML]="lang.value"></span>
        </option>
      </select>
      <mat-icon class="icon">arrow_drop_down</mat-icon>
    </mat-chip>
  </mat-chip-list>
</ng-template>

<ng-template #loginPopupTemp>
  <app-module-loader moduleId="login-popup" selector="app-login-popup" [load]="loadLoginPopup"></app-module-loader>
</ng-template>


<!-- download App  dropdown template -->
<ng-template #downloadAppDropdown>
  <mat-chip-list>
    <mat-chip *ngIf="isMobile && !isIos" class="toolbar-currency"><a [href]="variablesService.appLink.app_flyer" target="_blank" (click)="appDownloadEvent('android')"><mat-icon class="down">vertical_align_bottom</mat-icon>Get the app</a></mat-chip>
    <mat-chip *ngIf="isMobile && isIos" class="toolbar-currency"><a [href]="variablesService.appLink.app_flyer" target="_blank" (click)="appDownloadEvent('iOS')"><mat-icon class="down">vertical_align_bottom</mat-icon>Get the app</a></mat-chip>
    <mat-chip *ngIf="!isMobile" class="toolbar-currency" [matMenuTriggerFor]="downloadMenu"><mat-icon class="down">vertical_align_bottom</mat-icon>Get the app</mat-chip>
  </mat-chip-list>
  <mat-menu #downloadMenu="matMenu" class="menu">
    <div><a [href]="variablesService.appLink.app_flyer_android" target="_blank" (click)="appDownloadEvent('android')"><button class="menu-item" mat-menu-item>Android</button></a></div>
    <div><a [href]="variablesService.appLink.app_flyer" target="_blank" (click)="appDownloadEvent('iOS')"><button class="menu-item" mat-menu-item>iPhone</button></a></div>
  </mat-menu>
</ng-template>

<ng-container *ngIf="!isMobile && isHomev2" [ngTemplateOutlet]="drawerContainer"></ng-container>

<ng-template #drawerContainer>
  <div class="drawer-sidenav-wrapper" [class]="isDrawerOpened ? 'open-drawer':''">
    <div class="header">
      <app-close-btn top="27px" [left]="isMobile ? '16px':'32px'" (closeBtnListner)="isMobile ? sidenav.close(): toggleDrawer()" />
    </div>
    <div class="content-wrapper">
      <div class="profile-completion">
        <div class="profile-progress-wrapper">
          <div class="circular-wrapper">
            <div class="outer-circle"></div>
            <div class="inner-circle" *ngIf="!userData?.avtar?.cdn_path">
              <div class="initials">{{initials}}</div>
            </div>
            <div class="inner-circle" *ngIf="userData?.avtar?.cdn_path">
              <img class="profile-img" [attr.data-src]="userData?.avtar?.cdn_path" alt="user profile image">
            </div>
            <div class="progress-loader" [ngStyle]="{background: 'radial-gradient(closest-side, rgb(252, 252, 252) 79%, transparent 80%, transparent 100%), conic-gradient(rgb(54, 190, 199) '+ userData?.profile_complate +'%, transparent 0deg)'}"></div>
          </div>
        </div>
        <div class="profile-data-wrapper">
          <div class="name">{{userData?.full_name}}</div>
          <div class="email" [hidden]="userData?.email.includes('dummyketto.org')">{{userData?.email}}</div>
          <div class="complete-profile-wrapper">
            <a [href]="sipRedirect('editprofile')">
              <button mat-button class="btn">
                Complete Profile
                <mat-icon>chevron_right</mat-icon>
              </button>
            </a>
          </div>
        </div>
      </div>
      <div class="donation-impact-wrapper">
        <div class="impact-card" *ngFor="let item of livesImpactedList">
          <div class="numeric-value">{{item.value}}</div>
          <div class="impact-label">{{item.label}}</div>
        </div>
      </div>

      <div class="hubble-onboard" *ngIf="isMobile && currency === 'INR' && utilService.isBrowser">
        <app-hubble-onboard [pageInfo]="'profile'" [designMode]="'3'" (launchHubble)="launchHubble($event)"></app-hubble-onboard>
      </div>

      <div *ngIf="currency === 'INR' && isMobile && userData?.setu_enabled" class="billPayPitch">
        <app-component-loader [load]="true" selector="app-bill-pay-pitch" [inputs]="{type: 'short', position: 'profile'}" />
      </div>
      <div *ngIf="!(currency === 'INR' && isMobile)" class="spaceBtwn"></div>
      <div class="menu-list">
        <a class="item" *ngFor="let item of menuList" (click)="redirectionLogic(item)">
          <div class="menu-icon">
            <img [src]="'/assets/images/home-v2/' + item.iconName + '-menu-icon.png'" alt="menu icon">
          </div>
          <div class="label">{{item?.label}}</div>
          <div class="icon">
            <mat-icon>chevron_right</mat-icon>
          </div>
        </a>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #matChipItem>
  <span class="user-image-holder">
    <img loading="lazy" class="user-image" [attr.data-src]="userData?.avtar?.cdn_path" [alt]="userData?.full_name" [hidden]="showUserIcon === true" />
    <i class="icon-user1" *ngIf="showUserIcon === true"></i>
    <mat-icon>arrow_drop_down</mat-icon>
  </span>
</ng-template>
